/* unplugin-vue-components disabled */import script from "./ProjectDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDetail.vue?vue&type=style&index=0&id=f62c477c&scoped=true&lang=css"
import "./ProjectDetail.vue?vue&type=style&index=1&id=f62c477c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f62c477c"]])

export default __exports__